import './NuiBox.less';

import React, { FC, ElementType } from 'react';
import clsx from 'clsx';

const NuiBox: FC<{
    otherClass?: string;
    bgrClass?: string;
    dataAtid?: string;
    href?: string;
    title?: string;
    noPad?: boolean;
    oldStyle?: boolean;
    element?: ElementType;
    onClick?: (...args: any[]) => void;
}> = ({
    otherClass,
    oldStyle = false,
    bgrClass = oldStyle ? 'bg-white' : 'bg-white-box nui-box-br',
    dataAtid = 'nui-box',
    noPad = false,
    element: Element = 'div',
    children,
    ...restProps
}) => (
    <Element
        data-atid={dataAtid}
        className={clsx(bgrClass, 'nui-box br-radius-4', otherClass, { 'px-15': !noPad })}
        {...restProps}
    >
        {children}
    </Element>
);

export default NuiBox;
